import {RestRequestPOST} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";

const doFinishEvaluation = async (id) => {
    return await RestRequestPOST(Endpoints.EVALUATION_FINISH(id));
}

export default {
    doFinishEvaluation,
}